import React from 'react';
import { CheckIcon, VideoIcon } from 'lucide-react';
import { agent, offerItems } from '../../data/content';
import { CtaButton } from '../ui/CtaButton';
import { AgentPortrait } from '../ui/AgentPortrait';
export function Hero() {
  return <header className="w-full border-b border-ink-border/60 bg-ink-950" data-id="element-64" data-mp="cujiy6tux9xl">
      <div className="mx-auto max-w-6xl px-5 pb-16 pt-6 md:pb-24" data-id="element-65" data-mp="hvz2tvkataee">
        <div className="flex items-center justify-center border-b border-ink-border/60 pb-5 text-center" data-id="element-66" data-mp="muad27ei9mx5">
          <p className="text-sm font-bold text-white" data-id="element-67" data-mp="qv41r2zrv5r3">
            Método Fútbol Digital
            <span className="hidden font-medium text-subtle sm:inline" data-id="element-68" data-mp="vmm49vhg1ee6"> · Asesoramiento para padres de futbolistas</span>
          </p>
        </div>

        <div className="mx-auto mt-10 max-w-3xl text-center md:mt-16" data-id="element-69" data-mp="10kxei7bnhqwx">
          <p className="inline-flex items-center justify-center gap-2 text-sm font-bold text-brand-gold md:text-base" data-id="element-70" data-mp="15lbcewjjfkh8">
            <VideoIcon className="h-5 w-5" aria-hidden="true" data-id="element-71" data-mp="1akeimkb97wqs" />
            Videollamada personalizada con un Agente FIFA
          </p>
          <h1 className="mt-5 font-display text-[2.35rem] font-black leading-[1.08] text-white sm:text-5xl lg:text-[3.6rem]" data-id="element-72" data-mp="9lg90vc1oys6">
            ¿Tenés dudas sobre la carrera futbolística de tu hijo?
          </h1>
          <p className="mx-auto mt-6 max-w-2xl text-[17px] leading-relaxed text-body md:text-lg" data-id="element-73" data-mp="3rtffyfgzcjmb">
            Un asesoramiento personalizado para analizar su situación, responder tus dudas y
            ayudarte a tomar mejores decisiones antes de avanzar con una propuesta u oportunidad.
          </p>
        </div>

        <aside aria-label="Pack de asesoramiento" className="mx-auto mt-10 max-w-md rounded-3xl border border-ink-border bg-ink-card p-6 text-center shadow-panel md:p-8" data-id="element-74" data-mp="io8yct1o30fd">
          <div className="flex flex-col items-center" data-id="element-75" data-mp="1b5bm6b2ysiew">
            <AgentPortrait data-id="element-76" data-mp="1b639yzqblbum" />
            <p className="mt-4 font-bold text-white" data-id="element-77" data-mp="16e39n66c8gxi">{agent.name}</p>
            <p className="mt-1 text-sm leading-snug text-subtle" data-id="element-78" data-mp="16cs697gt1b6x">{agent.credential}</p>
          </div>
          <div className="mt-6 border-t border-ink-border pt-6" data-id="element-79" data-mp="30o0fbr9mfsh9">
            <p className="text-sm font-semibold text-brand-greenSoft" data-id="element-80" data-mp="35jz074vqqscx">
              Pack de asesoramiento para padres de futbolistas
            </p>
            <p className="mt-1 text-sm text-subtle" data-id="element-81" data-mp="2qu9q2k5o7e0i">Incluye:</p>
            <ul className="mt-4 space-y-2.5 text-left" data-id="element-82" data-mp="2vtmgtfznx58d">
              {offerItems.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-83" data-mp="2htuw6wen4qle">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand-green" strokeWidth={3} aria-hidden="true" data-id="element-84" data-mp="2muskzru5oivv" />
                  <span className="text-[15px] leading-snug text-white" data-id="element-85" data-mp="2cvjlykkfoe2n">{item}</span>
                </li>)}
            </ul>
            <p className="mt-4 text-sm leading-relaxed text-body" data-id="element-86" data-mp="66ogaselqx9o">
              +200 páginas de material profesional en PDF
            </p>
          </div>
          <div className="mt-6" data-id="element-87" data-mp="1vm8xuq5gs9bc">
            <CtaButton size="xl" fullWidth data-id="element-88" data-mp="1vnjzajbft4za" />
          </div>
        </aside>
      </div>
    </header>;
}